const pathConstants = {
  PRO_RESOURCE_PREFIX: '/m/ws/'
}

export default pathConstants



// WEBPACK FOOTER //
// ./src/constants/pathConstants.js